(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("static-image-source", [], factory);
	else if(typeof exports === 'object')
		exports["static-image-source"] = factory();
	else
		root["static-image-source"] = factory();
})(self, function() {
return 